import {
	SET_SPACES,
	SET_SPACE,
	CLEAR_SPACES,
	CLEAR_SPACE,
	ADD_SPACE,
	UPDATE_SPACE,
	REMOVE_SPACE,
} from './actionTypes';

export const space = (state = {}, action) => {
	switch (action.type) {
		case SET_SPACE:
			return action.payload;
		case UPDATE_SPACE:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_SPACE:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_SPACES:
			return action.payload;
		case ADD_SPACE:
			return [...state, action.payload];
		case UPDATE_SPACE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_SPACE:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_SPACES:
			return [];
		default:
			return state;
	}
};
